import axios from "axios";

export const create = payload => {
    return axios.post(`payment`, payload)
}